// extracted by mini-css-extract-plugin
export default {"container":"Products_container__yhU2V","products":"Products_products__T2HNE","menu":"Products_menu__+MiXd","list":"Products_list__dVCiF","product":"Products_product__jcgyT"};